import { render, staticRenderFns } from "./SubeFormType.vue?vue&type=template&id=d34ac270&"
import script from "./SubeFormType.vue?vue&type=script&lang=js&"
export * from "./SubeFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports